import {
  HateoasProjection,
  HateoasResource
} from "@lagoshny/ngx-hateoas-client";
import { SorCode } from "@app/models/rest/sor-code";
import { BaseEntity } from "@app/models/rest/base-entity";

@HateoasResource("visitTypes")
export class VisitType extends BaseEntity {
  description: string;
  sorCodes: SorCode[];
  meeting: boolean;
}

@HateoasProjection(VisitType, "id_only")
export class VisitType_IdOnlyProjection extends BaseEntity {
  description: string;
  meeting: boolean;
}
